import copy from "copy-to-clipboard";
import { useState } from "react";
import { IUseShareButton } from "./share-button.types";

const useShareButton: () => IUseShareButton = () => {
  const [isURLCopied, setURLCopied] = useState(false);

  const handleCopyURLToClipboard = (URL: string) => {
    copy(URL);
    setURLCopied(true);
  };
  return {
    isURLCopied,
    handleCopyURLToClipboard
  };
};

export { useShareButton };
